import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { estornarMultiplePagamento } from '../service';
import {
  CONTA_RECEBER_ESTORNAR_MULTIPLE_PAGAMENTO,
  CONTA_RECEBER_ESTORNAR_MULTIPLE_PAGAMENTO_PENDING,
  CONTA_RECEBER_ESTORNAR_MULTIPLE_PAGAMENTO_SUCCESS,
  CONTA_RECEBER_ESTORNAR_MULTIPLE_PAGAMENTO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast';

function* sagaEstornarMultiplePagamentoContaReceber(action) {
  yield put({ type: CONTA_RECEBER_ESTORNAR_MULTIPLE_PAGAMENTO_PENDING });

  try {
    const payload = action.data.map(item => ({
      contaId: item.idConta,
      pagamentoId: item.id
    }));

    yield call(estornarMultiplePagamento, payload);
    yield put({ type: CONTA_RECEBER_ESTORNAR_MULTIPLE_PAGAMENTO_SUCCESS });

    swal({
      title: 'Pagamento estornado com sucesso!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      window.location.reload();
    });

  } catch (error) {
    yield put({ type: CONTA_RECEBER_ESTORNAR_MULTIPLE_PAGAMENTO_FAILURE });

    // Verifica se é o erro específico de OFX (status 409)
    // O erro pode vir em diferentes estruturas dependendo de como o httpService retorna
    const errorMessage = error?.response?.data?.message || error?.data?.message;
    const errorStatus = error?.response?.status || error?.status;

    if (errorStatus === 409 && errorMessage && errorMessage.includes('conciliado com transação bancária (OFX)')) {
      AlertError(errorMessage);
    } else {
      AlertError('Falha ao excluir o registro! Verifique se a conta não possui vínculo com outra conta gerencial ou em lançamentos no financeiro.');
    }
  }
}

export default function* watchEstornarMultiplePagamentoContaReceber() {
  yield takeLatest(CONTA_RECEBER_ESTORNAR_MULTIPLE_PAGAMENTO, sagaEstornarMultiplePagamentoContaReceber);
}
